import { render, staticRenderFns } from "./BoardBaseCreate.vue?vue&type=template&id=1f5458e0&scoped=true"
import script from "./BoardBaseCreate.vue?vue&type=script&lang=js"
export * from "./BoardBaseCreate.vue?vue&type=script&lang=js"
import style0 from "./BoardBaseCreate.vue?vue&type=style&index=0&id=1f5458e0&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f5458e0",
  null
  
)

export default component.exports